import { isBrowser } from './is-browser';

const _isStyleNameSupport = (styleName: string | string[]): boolean => {
  if (isBrowser && window.document.documentElement) {
    const styleNameList = Array.isArray(styleName) ? styleName : [styleName];
    const { documentElement } = window.document;

    return styleNameList.some((name) => name in documentElement.style);
  }
  return false;
};

const detectFlexGapSupported = () => {
  if (window['flexGapSupported']) {
    return true;
  }
  if (!isBrowser) {
    return false;
  }
  // create flex container with row-gap set
  const flex = document.createElement('div');
  flex.style.display = 'flex';
  flex.style.flexDirection = 'column';
  flex.style.rowGap = '1px';

  // create two, elements inside it
  flex.appendChild(document.createElement('div'));
  flex.appendChild(document.createElement('div'));

  // append to the DOM (needed to obtain scrollHeight)
  document.body.appendChild(flex);
  const flexGapSupported = flex.scrollHeight === 1; // flex container should be 1px high from the row-gap
  document.body.removeChild(flex);
  window['flexGapSupported'] = flexGapSupported;
  return flexGapSupported;
};

export function isStyleNameSupport(styleName: string) {
  if (styleName === 'gap') {
    return detectFlexGapSupported();
  }
  return _isStyleNameSupport(styleName);
}

export function isStyleValueSupport(styleName: string, value: unknown) {
  if (!isStyleNameSupport(styleName)) {
    return false;
  }
  const ele = document.createElement('div');
  const origin = ele.style[styleName];
  ele.style[styleName] = value;
  return ele.style[styleName] !== origin;
}
